import { type ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface WidgetEmptyStateProps {
  children: ReactNode
  /** `xs` inside widget bodies, `sm` inside sheets/panels with more room. */
  size?: 'xs' | 'sm'
  className?: string
}

/**
 * The one "nothing to show" message (no data, loading failed, pick something first): centered
 * in whatever box it fills, muted foreground. Use it instead of re-typing the centering classes.
 */
export function WidgetEmptyState({ children, size = 'xs', className }: WidgetEmptyStateProps) {
  return (
    <div
      className={cn(
        'text-foreground/40 flex h-full items-center justify-center px-4 text-center',
        size === 'xs' ? 'text-xs' : 'text-sm',
        className
      )}
    >
      {children}
    </div>
  )
}
